import user from './user';
import { IS_PPP } from 'utils/appType';
import { ROUTES } from 'dictionary/routes';
import getAppBasename from 'config/getAppBasename';

export default function logoutUser() {
  const basename = getAppBasename();
  user.logout();
  window.location = IS_PPP
    ? `${basename === '/' ? '' : basename}${ROUTES.LOGIN}`
    : ROUTES.ROOT;
  return;
}
